import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { PageHeader } from "@/components/page-header";
import { PageShell } from "@/components/page-shell";
import { ProfileForm } from "@/components/task-forms/profile-form";
import { ensureConsumerQueryData, profileQueryOptions } from "@/lib/data";
import { requireSession } from "@/lib/session";

export const Route = createFileRoute("/profile_/identity")({
  component: IdentityEditPage,
  beforeLoad: requireSession,
  loader: () => ensureConsumerQueryData(profileQueryOptions),
});

function IdentityEditPage() {
  const navigate = useNavigate();

  return (
    <PageShell>
      <PageHeader
        title="Edit identity information"
        description="The details the dealer uses to verify who you are."
        backTo="/profile"
        backLabel="Back to profile"
      />
      <ProfileForm
        sections={["identity"]}
        required={[]}
        submitLabel="Save changes"
        onComplete={async () => {
          await navigate({ to: "/profile" });
        }}
      />
    </PageShell>
  );
}
